function updateHeaderCartCount(itemCount) {
  const cartIconBubble = document.getElementById('cart-icon-bubble');
  if (!cartIconBubble || typeof itemCount !== 'number') return;

  let bubble = cartIconBubble.querySelector('.cart-count-bubble');
  if (itemCount <= 0) {
    if (bubble) bubble.remove();
    return;
  }

  if (!bubble) {
    bubble = document.createElement('div');
    bubble.className = 'cart-count-bubble';
    cartIconBubble.appendChild(bubble);
  }

  bubble.innerHTML = `
    ${itemCount < 100 ? `<span aria-hidden="true">${itemCount}</span>` : ''}
    <span class="visually-hidden">${itemCount} items in cart</span>
  `;
}

function refreshHeaderCartCount() {
  return fetch('/cart.js')
    .then((r) => r.json())
    .then((cart) => {
      updateHeaderCartCount(cart.item_count);
      return cart;
    });
}

function isMobileMiniCart() {
  return window.matchMedia('(max-width: 749px)').matches;
}

function applyMiniCartState(popup, state) {
  if (!popup) return;

  popup.style.display = 'block';

  requestAnimationFrame(() => {
    if (isMobileMiniCart()) {
      if (state === 'peek') {
        popup.classList.add('is-peek');
        popup.classList.remove('is-open');
      } else {
        popup.classList.add('is-open');
        popup.classList.remove('is-peek');
      }
    } else {
      popup.classList.add('is-open');
      popup.classList.remove('is-peek');
    }
  });
}

function openMiniCartPopup(popup) {
  applyMiniCartState(popup, 'open');
}

function peekMiniCartPopup(popup) {
  applyMiniCartState(popup, 'peek');
}

function closeMiniCartPopup() {
  const popup = document.getElementById('mini-cart-popup');
  if (!popup) return;

  popup.classList.remove('is-open');

  if (isMobileMiniCart()) {
    popup.classList.add('is-peek');
    popup.style.display = 'block';
  } else {
    popup.classList.remove('is-peek');
    popup.style.display = 'none';
  }
}

function toggleMiniCartPopup() {
  const popup = document.getElementById('mini-cart-popup');
  if (!popup) return;

  if (popup.classList.contains('is-open')) {
    closeMiniCartPopup();
    return;
  }

  if (isMobileMiniCart() && popup.classList.contains('is-peek')) {
    openMiniCartPopup(popup);
    return;
  }

  fetch('/cart.js')
    .then((r) => r.json())
    .then((data) => showMiniCart(data, { mode: isMobileMiniCart() ? 'open' : 'open' }));
}

var pendingMiniCartResponse = null;
var pendingMiniCartTimer = null;

function clearPendingMiniCart() {
  if (pendingMiniCartTimer) {
    window.clearTimeout(pendingMiniCartTimer);
    pendingMiniCartTimer = null;
  }
}

function isMiniCartBlockedByQrPopup() {
  return isMobileMiniCart() && window.BADISM_QR_POPUP_OPEN === true;
}

function replayPendingMiniCart() {
  if (!pendingMiniCartResponse) return;

  const response = pendingMiniCartResponse;
  pendingMiniCartResponse = null;
  clearPendingMiniCart();

  window.setTimeout(function () {
    showMiniCart(response, { mode: 'peek', forceOpen: false });
  }, 50);
}

window.addEventListener('badism:qr-popup-opened', function () {
  clearPendingMiniCart();
  closeMiniCartPopup();
});

window.addEventListener('badism:qr-popup-closed', function () {
  if (pendingMiniCartResponse) {
    replayPendingMiniCart();
    return;
  }

  if (!isMobileMiniCart()) return;

  window.setTimeout(function () {
    fetch('/cart.js')
      .then((r) => r.json())
      .then((cart) => showMiniCart(cart, { mode: 'peek' }));
  }, 120);
});

function showMiniCart(response, options) {
  options = options || {};
  const mode = options.mode || (isMobileMiniCart() ? 'peek' : 'open');

  if (!options.forceOpen && isMiniCartBlockedByQrPopup()) {
    pendingMiniCartResponse = response;
    return;
  }

  if (typeof response.item_count === 'number') updateHeaderCartCount(response.item_count);

  const items = response.items || (response.item_count !== undefined ? [] : [response]);
  const list = document.getElementById('mini-cart-items-list');
  const moreEl = document.getElementById('mini-cart-more');

  if (list) {
    list.innerHTML = '';
    const displayItems = items.slice(0, 3);

    displayItems.forEach((item) => {
      const row = document.createElement('div');
      row.style.cssText = 'display:flex;gap:10px;margin-bottom:10px;align-items:center;';
      row.innerHTML = `
        <img src="${item.image || item.featured_image?.url || ''}" alt=""
          style="width:48px;height:48px;object-fit:cover;border-radius:2px;background:#f5f5f5;flex-shrink:0;">
        <div style="flex:1;min-width:0;">
          <p style="margin:0;font-size:12px;line-height:1.4;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;">
            ${item.product_title || item.title || ''}
          </p>
          <p style="margin:2px 0 0;font-size:12px;color:#555;">
            $${((item.final_price || item.price) / 100).toFixed(2)} USD
          </p>
        </div>
      `;
      list.appendChild(row);
    });

    if (items.length > 3 && moreEl) {
      moreEl.style.display = 'block';
      moreEl.textContent = `+ ${items.length - 3} more`;
    } else if (moreEl) {
      moreEl.style.display = 'none';
    }
  }

  const popup = document.getElementById('mini-cart-popup');
  if (popup) {
    if (mode === 'peek' && isMobileMiniCart()) {
      peekMiniCartPopup(popup);
    } else {
      openMiniCartPopup(popup);
    }
  }
}

document.addEventListener('DOMContentLoaded', () => {
  const popup = document.getElementById('mini-cart-popup');

  if (popup && isMobileMiniCart() && window.BADISM_QR_POPUP_OPEN !== true) {
    popup.style.display = 'block';
    popup.classList.add('is-peek');
  }

  if (popup) {
    let touchStartX = 0;
    let touchStartY = 0;

    popup.addEventListener('click', (e) => {
      if (!isMobileMiniCart() || e.target !== popup) return;
      e.preventDefault();
      toggleMiniCartPopup();
    });

    popup.addEventListener(
      'touchstart',
      (e) => {
        if (!isMobileMiniCart() || !popup.classList.contains('is-open')) return;
        touchStartX = e.touches[0].clientX;
        touchStartY = e.touches[0].clientY;
      },
      { passive: true }
    );

    popup.addEventListener(
      'touchend',
      (e) => {
        if (!isMobileMiniCart() || !popup.classList.contains('is-open') || !touchStartX) return;
        const touch = e.changedTouches[0];
        const diffX = touch.clientX - touchStartX;
        const diffY = touch.clientY - touchStartY;

        if (diffX > 45 && Math.abs(diffY) < 60) {
          closeMiniCartPopup();
        }

        touchStartX = 0;
        touchStartY = 0;
      },
      { passive: true }
    );
  }

  document.querySelectorAll('a[href="/cart"]').forEach((link) => {
    if (link.closest('#mini-cart-popup')) return;

    link.addEventListener('click', (e) => {
      if (isMobileMiniCart()) {
        e.preventDefault();
        toggleMiniCartPopup();
        return;
      }

      const currentPopup = document.getElementById('mini-cart-popup');
      if (!currentPopup) return;

      if (currentPopup.style.display !== 'block') {
        e.preventDefault();
        fetch('/cart.js')
          .then((r) => r.json())
          .then((data) => showMiniCart(data, { mode: 'open' }));
      }
    });
  });
});

document.addEventListener('click', (e) => {
  const btn = e.target.closest('.badism-quick-add');
  if (!btn) return;

  const id = btn.dataset.productId;
  const modal = document.getElementById('BadismVariant-' + id);
  if (!modal) return;

  document.querySelectorAll('.badism-variant-modal').forEach((m) => (m.style.display = 'none'));
  modal.style.display = 'block';
});

document.addEventListener('click', (e) => {
  const btn = e.target.closest('.badism-variant-btn');
  if (!btn) return;

  const variantId = btn.dataset.variantId;
  const modal = btn.closest('.badism-variant-modal');

  modal.style.display = 'none';

  showMiniCart({
    items: [
      {
        product_title: btn.closest('.badism-variant-modal').querySelector('span').textContent,
        title: btn.textContent,
        price: 0,
        image: ''
      }
    ]
  });

  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: variantId, quantity: 1 })
  })
    .then((r) => r.json())
    .then(() => refreshHeaderCartCount())
    .then((cart) => showMiniCart(cart))
    .catch((err) => console.error(err));
});

document.addEventListener('click', (e) => {
  const btn = e.target.closest('.badism-single-add');
  if (!btn) return;

  const variantId = btn.dataset.variantId;

  btn.classList.add('loading');
  btn.querySelector('.card__quick-add-plus').style.display = 'none';

  const card = btn.closest('.card-wrapper') || btn.closest('.card');
  const title = card ? (card.querySelector('.card__heading a') || card.querySelector('h3 a'))?.textContent?.trim() : '';
  const img = card ? card.querySelector('img')?.src : '';

  showMiniCart({
    items: [
      {
        product_title: title,
        title: '',
        price: 0,
        image: img
      }
    ]
  });

  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: variantId, quantity: 1 })
  })
    .then((r) => r.json())
    .then(() => refreshHeaderCartCount())
    .then((cart) => showMiniCart(cart))
    .catch((err) => console.error(err))
    .finally(() => {
      btn.classList.remove('loading');
      btn.querySelector('.card__quick-add-plus').style.display = '';
    });
});